var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarousal2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2345,
    height: 2413,
    viewBox: "0 0 2345 2413",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.475 1557.34L221.183 279.739L1692.73 75.5459L1940.33 1859.91L783.013 2020.5",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M623.23 615.727C587.968 615.717 553.497 626.164 524.173 645.746C494.849 665.329 471.991 693.168 458.489 725.742C444.988 758.316 441.449 794.161 448.322 828.747C455.193 863.332 472.167 895.102 497.097 920.04C522.026 944.978 553.789 961.962 588.372 968.847C622.955 975.731 658.802 972.207 691.381 958.717C723.96 945.226 751.807 922.379 771.399 893.062C790.993 863.745 801.452 829.277 801.454 794.015C801.457 746.741 782.684 701.4 749.261 667.965C715.839 634.531 670.504 615.741 623.23 615.727ZM672.086 892.086L606.732 901.569L596.188 828.942L526.514 839.038L517.031 773.67L586.719 763.549L576.584 693.9L641.965 684.417L652.074 754.066L724.7 743.536L734.183 808.916L661.556 819.46L672.086 892.086Z",
    fill: "#6095B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M623.23 615.727C658.486 615.737 692.949 626.201 722.259 645.796C751.569 665.391 774.412 693.237 787.898 725.812C801.383 758.388 804.908 794.231 798.023 828.809C791.14 863.387 774.159 895.148 749.226 920.076C724.293 945.004 692.527 961.979 657.948 968.855C623.368 975.731 587.526 972.199 554.952 958.706C522.38 945.214 494.539 922.366 474.951 893.051C455.362 863.737 444.906 829.272 444.903 794.015C444.902 770.598 449.513 747.411 458.475 725.776C467.436 704.143 480.573 684.485 497.132 667.929C513.692 651.373 533.352 638.241 554.988 629.284C576.624 620.328 599.813 615.721 623.23 615.727Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M724.7 743.549L652.073 754.079L641.965 684.43L576.584 693.913L586.718 763.562L517.031 773.683L526.514 839.051L596.188 828.955L606.731 901.581L672.086 892.099L661.556 819.472L734.182 808.929L724.7 743.549Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.682 168.135L370.168 344.596",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.332 147.368L519.817 323.829",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M644.994 126.602L669.479 303.062",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M794.643 105.834L819.128 282.295",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M944.292 85.0679L968.778 261.529",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.95 64.3008L1118.44 240.762",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.6 43.5337L1268.09 219.995",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.25 22.7671L1417.74 199.228",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1542.91 2L1567.4 178.474",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M940.663 569.836L1571.77 482.271",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M959.576 706.12L1590.68 618.554",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M978.49 842.416L1609.6 754.837",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M997.404 978.695L1355.41 929.021",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M643.631 1323.27L498.139 1343.39L518.253 1488.88L663.744 1468.77L643.631 1323.27Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M549.019 1388.73L595.613 1433.47L683.971 1317.13",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M737.416 1383.96L1678.65 1253.36",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M528.277 1557.34L523.919 1525.94L669.339 1505.77L689.518 1651.18L637.16 1658.46",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M574.476 1572.22L621.07 1616.97L709.428 1500.62",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M762.873 1567.47L1704.12 1436.86",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M653.926 1694.94L694.808 1689.27L700.329 1729.05",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M700.61 1729.27L734.898 1684.12",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M788.342 1750.96L1729.57 1620.35",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.68 1550.74C2217.52 1470.3 2106.73 1427.66 2008.76 1454.39C1908.46 1481.89 1828.96 1570.09 1773.24 1657.86C1717.51 1570.06 1645.82 1481.89 1545.52 1454.39C1447.5 1427.55 1336.73 1470.17 1274.59 1550.74C1180.13 1673.09 1170.71 1856.34 1386.7 2074.23C1504.32 2193.08 1636.23 2296.87 1779.43 2383.21C1916.39 2303.16 2056.08 2186.98 2167.68 2074.23C2382.7 1856.91 2373.45 1672.07 2279.68 1550.74Z",
    fill: "#A7ECFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.68 1550.74C2217.52 1470.3 2106.73 1427.66 2008.76 1454.39C1908.46 1481.89 1828.96 1570.09 1773.24 1657.86C1717.51 1570.06 1645.82 1481.89 1545.52 1454.39C1447.5 1427.55 1336.73 1470.17 1274.59 1550.74C1180.13 1673.09 1170.71 1856.34 1386.7 2074.23C1504.32 2193.08 1636.23 2296.87 1779.43 2383.21C1916.39 2303.16 2056.08 2186.98 2167.68 2074.23C2382.7 1856.91 2373.45 1672.07 2279.68 1550.74Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.32 1877.51H1636.75L1696.58 1733.83L1794.79 2238.42L1882.7 1838.88H2324.44",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0103 1277.37V1338.84",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0103 1412.26V1473.73",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1424.63L55.2272 1393.91",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.806 1357.19L172.033 1326.46",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M172.033 1424.63L118.806 1393.91",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2272 1357.19L2 1326.46",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2466 682.539V816.725",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M164.339 749.632H30.1533",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2036.63 1071.95V1164.46",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2082.89 1118.21H1990.38",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M707.335 1474H346.221C335.048 1474 325.991 1483.06 325.991 1494.23V1525.87C325.991 1537.04 335.048 1546.1 346.221 1546.1H707.335C718.508 1546.1 727.565 1537.04 727.565 1525.87V1494.23C727.565 1483.06 718.508 1474 707.335 1474Z",
    fill: "#6095B3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M707.335 1474H346.221C335.048 1474 325.991 1483.06 325.991 1494.23V1525.87C325.991 1537.04 335.048 1546.1 346.221 1546.1H707.335C718.508 1546.1 727.565 1537.04 727.565 1525.87V1494.23C727.565 1483.06 718.508 1474 707.335 1474Z",
    stroke: "#6095B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M672.709 1546V1570.07C672.708 1581.33 675.214 1592.42 680.017 1602.38C684.817 1612.34 691.768 1620.89 700.269 1627.26L728.801 1648.88C756.624 1669.87 779.365 1697.91 795.075 1730.59C810.784 1763.28 818.995 1799.63 819 1836.52V2398.04C819 2401.47 817.748 2404.78 815.52 2407.21C813.292 2409.63 810.27 2411 807.119 2411H246.842C243.702 2411 240.69 2409.63 238.468 2407.22C236.248 2404.79 235 2401.52 235 2398.08V1835.98C234.978 1799.25 243.084 1763.07 258.63 1730.5C274.175 1697.92 296.7 1669.93 324.291 1648.88L352.427 1627.41C360.831 1621 367.695 1612.48 372.432 1602.56C377.17 1592.63 379.644 1581.61 379.641 1570.42V1546.14",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M672.709 1546V1570.07C672.708 1581.33 675.214 1592.42 680.017 1602.38C684.817 1612.34 691.768 1620.89 700.269 1627.26L728.801 1648.88C756.624 1669.87 779.365 1697.91 795.075 1730.59C810.784 1763.28 818.995 1799.63 819 1836.52V2398.04C819 2401.47 817.748 2404.78 815.52 2407.21C813.292 2409.63 810.27 2411 807.119 2411H246.842C243.702 2411 240.69 2409.63 238.468 2407.22C236.248 2404.79 235 2401.52 235 2398.08V1835.98C234.978 1799.25 243.084 1763.07 258.63 1730.5C274.175 1697.92 296.7 1669.93 324.291 1648.88L352.427 1627.41C360.831 1621 367.695 1612.48 372.432 1602.56C377.17 1592.63 379.644 1581.61 379.641 1570.42V1546.14",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M660.906 2178.73L654.516 2120.73C653.049 2107.32 656.965 2093.89 665.402 2083.38C673.839 2072.87 686.108 2066.13 699.507 2064.66C712.907 2063.2 726.34 2067.11 736.854 2075.55C747.367 2083.98 754.098 2096.25 755.565 2109.66L761.955 2167.68L660.906 2178.73Z",
    fill: "#A7ECFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M761.955 2167.68L660.906 2178.73",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M699.552 2064.66C692.916 2065.39 686.488 2067.41 680.635 2070.62C674.782 2073.82 669.619 2078.16 665.44 2083.36C661.261 2088.57 658.149 2094.54 656.281 2100.96C654.414 2107.36 653.827 2114.08 654.555 2120.71L667.245 2236.74C668.71 2250.13 675.439 2262.4 685.952 2270.85C696.463 2279.28 709.897 2283.21 723.296 2281.74C736.696 2280.27 748.965 2273.54 757.404 2263.03C765.842 2252.52 769.759 2239.08 768.293 2225.68L755.603 2109.65C754.135 2096.25 747.404 2083.98 736.892 2075.55C726.381 2067.11 712.95 2063.19 699.552 2064.66Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M359.294 1855.89L341.403 1800.35C337.258 1787.52 338.378 1773.58 344.517 1761.58C350.655 1749.58 361.311 1740.51 374.138 1736.37C386.965 1732.21 400.914 1733.34 412.915 1739.47C424.916 1745.62 433.987 1756.26 438.132 1769.09L456.023 1824.63L359.294 1855.89Z",
    fill: "#A7ECFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M456.023 1824.63L359.294 1855.89",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M374.081 1736.37C361.256 1740.51 350.603 1749.58 344.465 1761.58C338.327 1773.58 337.208 1787.52 341.352 1800.35L377.237 1911.42C381.383 1924.25 390.454 1934.9 402.454 1941.04C408.396 1944.08 414.88 1945.91 421.533 1946.45C428.187 1946.99 434.88 1946.21 441.231 1944.15C447.583 1942.1 453.468 1938.82 458.55 1934.49C463.633 1930.17 467.813 1924.88 470.852 1918.93C473.892 1912.99 475.731 1906.51 476.265 1899.85C476.801 1893.21 476.019 1886.51 473.966 1880.16L438.081 1769.09C436.029 1762.74 432.744 1756.85 428.417 1751.78C424.09 1746.69 418.803 1742.51 412.86 1739.47C406.917 1736.43 400.434 1734.59 393.779 1734.06C387.126 1733.53 380.432 1734.31 374.081 1736.37Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M498.311 2025.86L531.193 1977.63C534.953 1972.11 539.763 1967.39 545.346 1963.74C550.931 1960.08 557.18 1957.57 563.739 1956.33C570.297 1955.09 577.036 1955.14 583.57 1956.51C590.103 1957.87 596.305 1960.51 601.819 1964.26C607.334 1968.03 612.055 1972.84 615.711 1978.42C619.366 1984.01 621.886 1990.26 623.127 1996.81C624.368 2003.37 624.305 2010.12 622.942 2016.65C621.578 2023.18 618.94 2029.38 615.181 2034.9L582.311 2083.11L498.311 2025.86Z",
    fill: "#A7ECFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M582.311 2083.11L498.311 2025.86",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M601.813 1964.26C590.674 1956.67 576.978 1953.82 563.736 1956.33C550.492 1958.83 538.788 1966.49 531.193 1977.63L465.442 2074.08C461.682 2079.59 459.044 2085.8 457.68 2092.33C456.318 2098.86 456.254 2105.59 457.495 2112.16C458.736 2118.72 461.256 2124.97 464.912 2130.55C468.569 2136.14 473.288 2140.94 478.803 2144.7C484.317 2148.46 490.519 2151.1 497.053 2152.47C503.586 2153.82 510.325 2153.89 516.883 2152.65C523.442 2151.41 529.691 2148.89 535.276 2145.24C540.86 2141.58 545.669 2136.85 549.429 2131.34L615.18 2034.9C622.773 2023.75 625.63 2010.05 623.123 1996.81C620.617 1983.56 612.951 1971.86 601.813 1964.26Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M583 1769.81L615.869 1721.57C623.555 1710.66 635.225 1703.2 648.361 1700.82C661.498 1698.43 675.045 1701.31 686.077 1708.83C697.107 1716.35 704.737 1727.91 707.319 1741.01C709.899 1754.11 707.224 1767.7 699.87 1778.84L666.988 1827.06L583 1769.81Z",
    fill: "#A7ECFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M669.852 1827.77L585.864 1770.51",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M685.651 1708.83C674.514 1701.24 660.815 1698.38 647.569 1700.88C634.324 1703.39 622.616 1711.06 615.018 1722.19L549.267 1818.64C545.387 1824.14 542.642 1830.38 541.192 1836.96C539.741 1843.54 539.613 1850.34 540.817 1856.98C542.021 1863.61 544.532 1869.93 548.202 1875.59C551.874 1881.24 556.633 1886.11 562.201 1889.91C567.771 1893.7 574.039 1896.35 580.642 1897.7C587.247 1899.06 594.052 1899.08 600.665 1897.78C607.279 1896.48 613.566 1893.87 619.164 1890.11C624.76 1886.36 629.555 1881.52 633.267 1875.9L699.018 1779.45C706.607 1768.31 709.462 1754.62 706.955 1741.38C704.449 1728.13 696.786 1716.42 685.651 1708.83Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M354.962 2229.27L313.799 2187.91C304.289 2178.36 298.967 2165.41 298.999 2151.93C299.031 2138.45 304.417 2125.54 313.971 2116.03C323.527 2106.53 336.467 2101.2 349.947 2101.24C363.427 2101.26 376.341 2106.65 385.85 2116.2L427.026 2157.57L354.962 2229.27Z",
    fill: "#A7ECFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M427.027 2157.57L354.962 2229.27",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M313.978 2116.02C304.424 2125.53 299.037 2138.44 299.004 2151.92C298.97 2165.4 304.292 2178.35 313.799 2187.91L396.125 2270.64C405.632 2280.19 418.547 2285.58 432.027 2285.62C445.507 2285.66 458.448 2280.33 468.004 2270.82C477.561 2261.31 482.949 2248.41 482.983 2234.92C483.019 2221.44 477.696 2208.5 468.19 2198.95L385.851 2116.2C376.344 2106.64 363.43 2101.26 349.951 2101.22C336.473 2101.19 323.533 2106.51 313.978 2116.02Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousal2);
export default __webpack_public_path__ + "static/media/Carousal_2.c7e7d52239444192ef54a4a2d678a6d5.svg";
export { ForwardRef as ReactComponent };